import React from 'react';
import {DownloadCsvButton} from '@igp/shared/components/download';
import type {UseDownloadProps, UseDownloadResult} from '@igp/shared/redux/download';
import {useDownload} from '@igp/shared/redux/download';

import {DebtResponsibleMasterAgentsServiceTypes, type DebtResponsibleMasterAgentViewModelKeys} from '../types';

import {localized} from './DataGrid';

export type DebtResponsibleMasterAgentsDownloadCsvButtonProps = Pick<
    UseDownloadProps<DebtResponsibleMasterAgentViewModelKeys>,
    'filename' | 'keys' | 'mode' | 'filter' | 'total'
>;

function useDebtResponsibleMasterAgentsDownload(props: DebtResponsibleMasterAgentsDownloadCsvButtonProps): UseDownloadResult {
    const {handleDownload, isProgress} = useDownload<DebtResponsibleMasterAgentViewModelKeys>({
        ...props,
        strategySymbol:
            props.mode === 'client'
                ? DebtResponsibleMasterAgentsServiceTypes.downloadClientStrategy
                : DebtResponsibleMasterAgentsServiceTypes.downloadServerStrategy,
        headersLocalization: localized,
    });

    return {handleDownload, isProgress};
}

export function DebtResponsibleMasterAgentsDownloadCsvButton({
    filename,
    total,
    keys,
    filter,
    mode,
}: DebtResponsibleMasterAgentsDownloadCsvButtonProps) {
    const {handleDownload, isProgress} = useDebtResponsibleMasterAgentsDownload({filename, total, keys, filter, mode});

    return <DownloadCsvButton onClick={handleDownload} loading={isProgress} disabled={isProgress} />;
}
